/*
  Sticky Add to Cart for the KNOTT product page.

  The theme ships its own <sticky-add-to-cart>, but it watches for the native
  product form's add-to-cart button and this page has no native form: the real
  button belongs to <knott-tiers>. So the theme's bar never flipped data-stuck
  and simply never appeared. Its own button was the wrong one to show in any
  case, because it posts a single unit of the current variant at full price and
  would have walked straight past the chosen offer.

  This bar therefore does not add anything itself. It mirrors the real button's
  label and disabled state and forwards clicks to it, so the offer, the picked
  pieces and the exact total ("ADD 3 TO CART — $55.00") stay the single source
  of truth, and there is nothing to keep in sync by hand.

  It shows in one band only: after the real button has scrolled above the
  viewport, and before the footer comes into view. Once the footer is on
  screen the shopper has reached the end of the page, and a bar pinned over
  the contact links and policy menu is just covering them up.

  The scroll handler does no layout work. Both boundaries are measured once up
  front and again whenever something could have moved them (resize,
  late-loading images, picking pieces), so each scroll event only compares
  numbers. That keeps scrolling cheap, and unlike an IntersectionObserver or a
  requestAnimationFrame throttle it does not go quiet when the page is not
  being painted.

  A class is also set on <body>. The WhatsApp bubble has to lift clear of this
  bar, and a plain class is the dependable way to tell it to: styling it with
  body:has(.kt-sticky.is-on) matched the element but did not consistently
  restyle it when the class changed.
*/
(function () {
  function init() {
    var real = document.querySelector('knott-tiers [data-kt-add]');
    if (!real || document.querySelector('[data-kt-sticky]')) return;

    var tiers = real.closest('knott-tiers');
    var label = real.querySelector('[data-kt-label]');
    var footer = document.querySelector('footer');

    var bar = document.createElement('div');
    bar.className = 'kt-sticky';
    bar.setAttribute('data-kt-sticky', 'false');
    bar.innerHTML =
      '<button type="button" class="knott-btn kt-sticky__btn">' +
      '<span data-kt-sticky-label></span></button>';
    document.body.appendChild(bar);

    var btn = bar.querySelector('.kt-sticky__btn');
    var mirror = bar.querySelector('[data-kt-sticky-label]');

    /* Where the bottom of the real button sits in the document, and where the
       top of the footer does. Infinity when there is no footer, so the upper
       boundary simply never applies. */
    var passedAt = 0;
    var footerAt = Infinity;
    var shown = null;

    function apply() {
      var y = window.scrollY;
      var on = y > passedAt && y + window.innerHeight < footerAt;
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('data-kt-sticky', on ? 'true' : 'false');
      document.body.classList.toggle('kt-has-sticky', on);
    }

    function recalc() {
      var y = window.scrollY;
      passedAt = real.getBoundingClientRect().bottom + y;
      footerAt = footer ? footer.getBoundingClientRect().top + y : Infinity;
      apply();
    }

    function sync() {
      var text = (label || real).textContent;
      mirror.textContent = text ? text.trim() : 'Add to cart';
      btn.disabled = !!real.disabled;
    }

    sync();
    recalc();

    btn.addEventListener('click', function () {
      real.click();
    });

    addEventListener('scroll', apply, { passive: true });
    addEventListener('resize', recalc, { passive: true });
    addEventListener('load', recalc);

    /* Choosing an offer grows the picks list above the button, and the label
       gains the running total. Both are handled by the same observer, which
       also catches anything below that shifts the footer. */
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        sync();
        recalc();
      }).observe(tiers || real, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    /* Images and embeds below the fold settle after load and move the footer,
       so the boundary is re-read once things have stopped shifting. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(recalc).observe(document.body);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();